var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetabolicFoodCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1042,
    height: 466,
    viewBox: "0 0 1042 466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2065",
    x: 0,
    y: 0,
    width: 1042,
    height: 466,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 24,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2066",
    "data-name": "Rectangle 2066",
    width: 294,
    height: 200,
    transform: "translate(37 516)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2249",
    "data-name": "Group 2249",
    transform: "translate(-119.063 -2346.906)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 119.06, 2346.91)",
    filter: "url(#Rectangle_2065)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2065-2",
    "data-name": "Rectangle 2065",
    width: 967,
    height: 391,
    rx: 12,
    transform: "translate(37.5 13.5)",
    fill: "#1d2226"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_75",
    "data-name": 75,
    transform: "translate(200.563 2662.906)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "75")), /*#__PURE__*/React.createElement("text", {
    id: "Food_Eaten",
    "data-name": "Food Eaten",
    transform: "translate(223.313 2689.906)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Food Eaten")), /*#__PURE__*/React.createElement("text", {
    id: "_1_hr",
    "data-name": "1 hr",
    transform: "translate(615.248 2689.906)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1 hr")), /*#__PURE__*/React.createElement("text", {
    id: "_2_hr",
    "data-name": "2 hr",
    transform: "translate(1031.313 2689.906)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2 hr")), /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": 100,
    transform: "translate(200.563 2612.906)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100")), /*#__PURE__*/React.createElement("text", {
    id: "_125",
    "data-name": 125,
    transform: "translate(200.563 2562.906)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "125")), /*#__PURE__*/React.createElement("text", {
    id: "_150",
    "data-name": 150,
    transform: "translate(200.563 2512.906)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "150")), /*#__PURE__*/React.createElement("text", {
    id: "_175",
    "data-name": 175,
    transform: "translate(200.563 2462.906)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "175")), /*#__PURE__*/React.createElement("g", {
    id: "divider",
    transform: "translate(200.563 2467.906)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    id: "divider-2",
    "data-name": "divider",
    width: 867.368,
    height: 1,
    rx: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "divider-3",
    "data-name": "divider",
    transform: "translate(200.563 2517.906)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    id: "divider-4",
    "data-name": "divider",
    width: 867.368,
    height: 1,
    rx: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "divider-5",
    "data-name": "divider",
    transform: "translate(200.563 2567.906)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    id: "divider-6",
    "data-name": "divider",
    width: 867.368,
    height: 1,
    rx: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "divider-7",
    "data-name": "divider",
    transform: "translate(200.563 2617.906)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    id: "divider-8",
    "data-name": "divider",
    width: 867.368,
    height: 1,
    rx: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "divider-9",
    "data-name": "divider",
    transform: "translate(200.563 2667.906)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    id: "divider-10",
    "data-name": "divider",
    width: 867.368,
    height: 1,
    rx: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Paneer_Sandwich",
    "data-name": "Paneer Sandwich",
    transform: "translate(261.313 2721.906)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Paneer Sandwich")), /*#__PURE__*/React.createElement("text", {
    id: "Blood_Glucose",
    "data-name": "Blood Glucose",
    transform: "translate(200.563 2403.141)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Blood Glucose")), /*#__PURE__*/React.createElement("text", {
    id: "_101_mg_dl",
    "data-name": "101 mg/dl",
    transform: "translate(352.563 2405.141)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "101 mg/dl")), /*#__PURE__*/React.createElement("text", {
    id: "Chicken_Salad",
    "data-name": "Chicken Salad",
    transform: "translate(402.313 2721.641)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Chicken Salad")), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M.307,86.632C6.981,89.1,35.2,75.491,46.628,78.994c9,2.758-11.518-35.554,0-32.877C68.489,51.2,79.824,27.4,89.962,39.533S126.4.266,144.532.266s45.129,14.1,51.97,0c6.552-13.5,23.77,3.576,44.176,0,22.524-3.947,14.109,8.541,40.984,4.5,14.324-2.156,25.8,2.04,38.6,8.561s10.3,9.337,39.091,14.364c23.762,4.149,16.3,10.128,39.58,11.847s46.359,2.094,70.942,6.583c16.839,3.075,15.946-4.072,33.131-6.583-1.756,13.109,31.827-6.929,39.106,0,7.626,7.259,23.192-.592,31.183,0,13.865,1.052,5.514,9.591,24.949,6.583,29.008-4.489,26.768,1.8,40.535,0s51.185,1.365,62.985,6.3,9.744,4.1,34.819,4.1,3.286,4.66,17.052,3.313,54.82-1.58,59.245-7.415",
    transform: "translate(235.492 2572.682)",
    fill: "none",
    stroke: "#ffab3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    "data-name": "Line",
    d: "M1.519,121.281c.3.212,4.879-3.211,6.027-2.8,6.616,2.452,25.135-5.526,41.117-14.553,17.316-9.78,32.653-4.514,50.463-2.508s23.747-21.566,43.537-24.575,37.563-5.239,67.248-9c20.037-2.539,20.128.508,30.669,3.945,4.218,1.38,11.3,2.993,24.006,4.052,39.084,3.26,33.448,7.523,51.258,1s5.368,8.568,35.052,10.574,29.094-2.508,53.831,0c20.136,2.041,13.321-3.185,33.463,0,3.617.563,18.953.278,23.278,2.564,7.379,3.9,30.514,2.783,40.737,2.386,11.522-.439,25.746,1.239,29.339,0,1.482-.525,14.594,5.553,22.241,4.9,24.753-2.126,16.677-1.745,21.768,0,.061.1,13.295.152,15.4,0,13.853-1,27.4-2.758,39.275,0s19.192,6.663,44.424,6.663,40.824,3.761,54.677,3.009,53.64,3.26,58.092,0",
    transform: "translate(235.492 2538.709)",
    fill: "none",
    stroke: "#c4bca6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_645",
    "data-name": "Ellipse 645",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(382.313 2711.375)",
    fill: "#c3bca7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_646",
    "data-name": "Ellipse 646",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(239.313 2711.641)",
    fill: "#ffac41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2248",
    "data-name": "Group 2248",
    transform: "translate(-8.688 2221.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8128",
    "data-name": "Path 8128",
    d: "M9.5,0A9.5,9.5,0,1,1,0,9.5,9.5,9.5,0,0,1,9.5,0Z",
    transform: "translate(231 423)",
    fill: "#fff",
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-5108.676 658.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M58.181,0c-.509,0-.947.209-1.019.485L56,4.937c-.014.053.019.107.088.145l.532.293v5.059c0,.283.419.513.934.513s.934-.23.934-.513V.172C58.492.077,58.353,0,58.181,0Zm-.311,10.433c0,.094-.14.171-.311.171s-.311-.077-.311-.171V5.3a.148.148,0,0,0-.091-.121L56.642,4.9,57.778.535a.2.2,0,0,1,.091-.112V10.434Z",
    transform: "translate(5294.574 -231.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M4.36,2.525V.171C4.36.086,4.244.013,4.089,0a.361.361,0,0,0-.342.125L3.009,1.633,2.486.139C2.458.058,2.329,0,2.18,0S1.9.058,1.874.139L1.351,1.633.612.127A.362.362,0,0,0,.271,0C.116.013,0,.085,0,.171V2.525c0,.3.3.572.8.707.278.076.451.23.451.4v6.783c0,.259.335.485.78.524.051,0,.1.007.153.007a1.463,1.463,0,0,0,.607-.122c.209-.1.329-.24.329-.391v-6.8c0-.171.173-.324.451-.4C4.055,3.1,4.36,2.826,4.36,2.525Zm-1.074.4c-.491.135-.8.405-.8.707v6.8c0,.05-.04.1-.11.13a.515.515,0,0,1-.256.038c-.144-.013-.257-.1-.257-.187V3.632c0-.3-.3-.572-.8-.707C.8,2.849.623,2.7.623,2.525V1.464l.478.975a.347.347,0,0,0,.312.127c.145,0,.267-.06.294-.139l.473-1.35.473,1.35c.027.078.149.136.294.139a.35.35,0,0,0,.312-.127l.478-.975V2.525C3.737,2.7,3.564,2.849,3.287,2.926Z",
    transform: "translate(5345 -231)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetabolicFoodCompare);
export default __webpack_public_path__ + "static/media/metabolicFoodCompare.a7ffece24c3f588eb0d88156ed7f0cfe.svg";
export { ForwardRef as ReactComponent };